import React from 'react';
import {
    UsagePriceFont,
    UsagePricingDataContainer,
} from './BundleCards.styled';
import { useSelector } from 'react-redux';
import { setCurrencyFormat } from 'src/utils/util';

const PricingContainer = ({
    pricingLabel,
    price,
    subPrice,
    alignItemsContainer,
    marginContainer,
    heightContainer,
    paddingContainer,
}) => {
    const { orderBasicDetails, selectedTabId } = useSelector(
        (state) => state.orderSummaryReducer
    );

    const currencyISOCode = useSelector(
        (state) => state.orderSummaryReducer.billingSummary?.cartSummary?.currencyISOCode
    );
    return (
        <>
            <UsagePricingDataContainer
                alignItems={
                    alignItemsContainer ? alignItemsContainer : 'flex-end'
                }
                flexDirection={'column'}
                width={'100%'}
                margin={marginContainer ? marginContainer : '0 0 5px 5px'}
                height={heightContainer}
                padding={paddingContainer}
            >
                {pricingLabel ? (
                    <UsagePriceFont
                        color="#202124"
                        fontFamily="AvenirNextWorld Demi"
                        margin={'0 0 5px 0'}
                    >
                        {pricingLabel}
                    </UsagePriceFont>
                ) : null}

                <UsagePriceFont
                    color={
                        orderBasicDetails?.currentOrderType === 'ZOR'
                            ? subPrice || subPrice === 0
                                ? '#E5047E'
                                : '#202124'
                            : subPrice !== undefined && subPrice !== null
                            ? '#E5047E'
                            : '#202124'
                    }
                    fontSize="14px"
                    textDecoration={
                        orderBasicDetails?.currentOrderType === 'ZOR'
                            ? subPrice || subPrice === 0
                                ? 'line-through'
                                : 'none'
                            : subPrice !== undefined && subPrice !== null
                            ? 'line-through'
                            : 'none'
                    }
                    margin={'0 0 5px 0'}
                >
                    {orderBasicDetails?.currentOrderType === 'ZOR'
                        ? selectedTabId == 'billingSummary' && price === 0
                            ? 'Pricing not available'
                            : price || price === 0
                            ? setCurrencyFormat(price, true, {currency: currencyISOCode})
                            : null
                        : price !== undefined && price !== null
                        ? setCurrencyFormat(price, true, {currency: currencyISOCode})
                        : null}
                </UsagePriceFont>

                {orderBasicDetails?.currentOrderType !== 'ZOR' &&
                subPrice !== undefined &&
                subPrice !== null ? (
                    <UsagePriceFont color="#202124" fontSize="14px">
                        {setCurrencyFormat(subPrice, true, {currency: currencyISOCode})}
                    </UsagePriceFont>
                ) : (
                    ((subPrice !== undefined && subPrice !== null) ||
                        subPrice === 0) &&
                    orderBasicDetails?.currentOrderType === 'ZOR' && (
                        <UsagePriceFont color="#202124" fontSize="14px">
                            {setCurrencyFormat(subPrice, true, {currency: currencyISOCode})}
                        </UsagePriceFont>
                    )
                )}
            </UsagePricingDataContainer>
        </>
    );
};

export default PricingContainer;
